<script>
import AccordionItem from "../../components/accordion/AccordionItem.vue";
import Icon from "../../components/Icon.vue";
import {useI18n} from "vue-i18n";
import RepaymentProcess from "./RepaymentProcess.vue";
import PaymentProcessors from "./PaymentProcessors.vue";
import PaymentProcessorCard from "./PaymentProcessorCard.vue";
import {usePaymentProcessorStore} from "@/javascript/stores/paymentProcessors";
import {useAnalyticEventStore} from "@/javascript/stores/analyticEvents";
import TabNavigation from "../../components/TabNavigation.vue";
import TabsComponent from "../../components/dashboard/Tabs.vue";

export default {
  name: "PaymentProcessorPanel",
  components: {
    TabsComponent,
    TabNavigation, PaymentProcessorCard, PaymentProcessors, RepaymentProcess, AccordionItem, Icon},
  setup() {
    const {t} = useI18n();
    const processorStore = usePaymentProcessorStore();
    const analyticEventStore = useAnalyticEventStore();
    return {t, processorStore, analyticEventStore};
  },
  data() {
    return {
      isVisible: false,
      activeTab: 'payment-processor-tab',
      previousTab: null,
    };
  },
  computed: {
    //Even if Stripe is active, if they have a helcim account, documents tab will show
    hasHelcimAccount() {
      const helcimProcessor = this.getProcessorByType('HELCIM');
      return !!helcimProcessor && helcimProcessor.active;
    },
    availableTabs() {
      //TODO: Add History Tab (or button) after submission process is complete
      const tabs = [
        { id: 'payment-processor-tab', label: 'Details' }
      ];

      if (this.hasHelcimAccount) {
        tabs.push({ id: 'documents-tab', label: 'AllGive Repayment' });
      }

      return tabs;
    }
  },
  mounted() {
    this.activeTab = 'payment-processor-tab';
    setTimeout(() => {
      this.isVisible = true;
    }, 100);
  },
  methods: {
    switchTab(tab) {
      this.previousTab = this.activeTab;
      this.activeTab = tab;
      this.analyticEventStore.setOrganizationId(this.processorStore.organizationId);
      this.analyticEventStore.logEvent({
        action: `payment-processor-switch-to-${tab}`,
      });
    },
    getProcessorByType(type) {
      return this.processorStore.getProcessorByType(type) || null;
    },
  },
};
</script>

<template>
  <div class="donations-index-wrapper w-full p-4 pt-2">
    <div class="bg-white rounded-xl border border-gray-300 p-4 px-6 flex justify-between items-center">
      <p class="pb-0 font-bold">
        Payment Processors
      </p>
    </div>
    <TabsComponent
      v-model="activeTab"
      :tabs="availableTabs"
      class="mt-4 border border-gray-300 rounded-xl overflow-hidden text-xs"
      @tab-changed="switchTab"
    >
      <template #payment-processor-tab>
        <div class="content-section">
          <payment-processors />
        </div>
      </template>

      <template #documents-tab>
        <div class="content-section">
          <repayment-process />
        </div>
      </template>
    </TabsComponent>
  </div>
</template>

<style scoped lang="scss">
.payment-processor-container {
  @apply h-full flex bg-gray-50 p-0 m-0;
  max-height: 93dvh;
}

.main-content {
  @apply flex-1 opacity-0 transform translate-y-4 transition-all duration-700 ease-out max-h-full h-full overflow-y-auto;
}

.content-visible {
  @apply opacity-100 transform translate-y-0;
}

.content-section {
  @apply bg-white border border-gray-200 h-auto min-h-full;
  min-height: 80vh;
}


@media (max-width: 768px) {
  .payment-processor-container {
    @apply flex-col;
  }

  .main-sidebar {
    @apply w-full;
  }

  .main-content {
    @apply min-h-screen;
  }
}
</style>
